import React, { useState } from 'react';
import InputField from './InputField'; // Importing the new InputField component
import Button from './Button';
import emailjs from 'emailjs-com';
import { FaRegCalendar } from "react-icons/fa";

const EmailForm: React.FC = () => {
    const [formData, setFormData] = useState({
        name: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
    });

    const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus('sending');

        try {
            await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
                {
                    name: formData.name,
                    lastName: formData.lastName,
                    email: formData.email,
                    phone: formData.phone,
                    message: formData.message,
                },
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY || ''
            );

            setStatus('sent');
        } catch (error) {
            console.error('Email sending error:', error);
            setStatus('error');
        }
    };

    return (
        <div className='p-4 lg:p-10 lg:bg-darkGrey mx-auto lg:min-w-[800px] lg:border border-grey justify-center'>
            <Button
                type='button'
                status='idle'
                text='Schedule a Call'
                icon={FaRegCalendar}
                className='flex justify-center mb-8 px-4 gap-2 lg:justify-start items-center lg:hidden lg:px-4 '
                link='https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2OhvRoLbGuz5syGZxlLJURue4lNNZOX-QBcBaT4VH_AXgcwoscKokAiAm4lINc0kBFxaZpHAZ-'
            />
            {status === 'sent' ?
                <p className='text-white text-center'>Your message has been sent successfully!</p> :
                <form onSubmit={handleSubmit} className='grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10'>
                    <InputField
                        type='text'
                        name='name'
                        value={formData.name}
                        onChange={handleChange}
                        label='First Name'
                        required
                    />
                    <InputField
                        type='text'
                        name='lastName'
                        value={formData.lastName}
                        onChange={handleChange}
                        label='Last Name'
                        required
                    />
                    <InputField
                        type='email'
                        name='email'
                        value={formData.email}
                        onChange={handleChange}
                        label='Email'
                        required
                    />
                    <InputField
                        type='tel'
                        name='phone'
                        value={formData.phone}
                        onChange={handleChange}
                        label='Phone'
                        required
                    />
                    <div className='col-span-1 lg:col-span-2 mb-4'>
                        <InputField
                            type='textarea'
                            name='message'
                            value={formData.message}
                            onChange={handleChange}
                            label='Message'
                            required
                            rows={4}
                        />
                    </div>
                    <div className='col-span-1 lg:col-span-2 mb-4 flex justify-center w-full'>
                        <Button
                            type='submit'
                            status={status}
                            text={status === 'sending' ? 'Sending...' : 'Submit'}
                            disabled={status === 'sending'}
                        />
                    </div>
                </form>
            }
        </div>
    );
};

export default EmailForm;
